import { AuthProviderFactory } from './AuthProviderFactory';

export class AuthProvider {
    constructor() {
        this.authProviderFactory = new AuthProviderFactory();
        this.authProvider = this.authProviderFactory.build(null);
    }

    initProvider = (authConfig, clientIdUrlParam, featureFlags) => {
        this.authProvider = this.authProviderFactory.build(authConfig);
    };

    login = (language) => {
        this.authProvider.login(language);
    } 

    silentAuthentication = (callback) => {
        return this.authProvider.silentAuthentication(callback);
    };

    otcAuthentication = (code, userName) => {
        return this.authProvider.otcAuthentication(code, userName);
    };

    passUserName = (userName) => {
        return this.authProvider.passUserName(userName);
    };

    handleAuthentication = async (callback) => {
        return this.authProvider.handleAuthentication(callback);
    };

    logout = () => {
        return this.authProvider.logout();
    };

    getAccessToken = () => {
        return this.authProvider.getAccessToken();
    };

    getProfile = () => {
        return this.authProvider.getProfile();
    };

    getTokenTimeToLive = () => {
        return this.authProvider.getTokenTimeToLive();
    };

    isAuthenticated = () => {
        return this.authProvider.isAuthenticated();
    };

    isRegularAuthentication = (authResult) => {
        return this.authProvider.isRegularAuthentication(authResult);
    };

    redirect = (app, route) => {
        return this.authProvider.redirect(app, route);
    } 
}

const auth = new AuthProvider();
export default auth;

